import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Plus } from "lucide-react";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../components/ui/dialog";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../components/ui/table";
import { Page, Field } from "../components/Layout";
import { api, notifyErr, fmtDate } from "../lib/api";
import { useCustomers } from "../lib/hooks";

export default function Clienti() {
  const nav = useNavigate();
  const { customers, reload } = useCustomers();
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ name: "", timezone: "Europe/Rome", notes: "" });
  const save = async () => {
    try {
      const r = await api.post("/customers", form);
      toast.success("Cliente creato con archivio dedicato");
      setOpen(false);
      nav(`/clienti/${r.data.id}`);
    } catch (e) { notifyErr(e); }
  };
  return (
    <Page title="Clienti e Predictive" subtitle="Ogni cliente ha connessioni AlFa Dial, archivio, elaborazioni e report completamente separati."
      testid="clienti-page" actions={<Button className="rounded-sm bg-[#0047FF] h-8" onClick={() => setOpen(true)} data-testid="new-customer-btn"><Plus size={14} className="mr-1" />Nuovo cliente</Button>}>
      <div className="bg-white border rounded-sm overflow-x-auto">
        <Table>
          <TableHeader><TableRow>
            <TableHead>Cliente</TableHead><TableHead>Fuso orario</TableHead><TableHead className="text-right">Predictive</TableHead>
            <TableHead className="text-right">Registrazioni</TableHead><TableHead className="text-right">Opportunità</TableHead><TableHead>Creato</TableHead><TableHead />
          </TableRow></TableHeader>
          <TableBody>
            {customers.map((c) => (
              <TableRow key={c.id} className="row-hover cursor-pointer" onClick={() => nav(`/clienti/${c.id}`)} data-testid={`customer-row-${c.id}`}>
                <TableCell className="font-medium">{c.name}</TableCell>
                <TableCell className="font-mono text-xs">{c.timezone}</TableCell>
                <TableCell className="text-right tabular-nums">{c.predictives}</TableCell>
                <TableCell className="text-right tabular-nums">{c.recordings}</TableCell>
                <TableCell className="text-right tabular-nums">{c.opportunities}</TableCell>
                <TableCell className="text-xs">{fmtDate(c.created_at)}</TableCell>
                <TableCell className="text-right"><Link to={`/clienti/${c.id}`} className="text-[#0047FF] text-sm hover:underline" data-testid={`open-customer-${c.id}`}>Configura →</Link></TableCell>
              </TableRow>
            ))}
            {!customers.length && <TableRow><TableCell colSpan={7} className="text-center text-neutral-500 py-10">Nessun cliente. Crea il primo cliente per iniziare.</TableCell></TableRow>}
          </TableBody>
        </Table>
      </div>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="rounded-sm" data-testid="new-customer-dialog">
          <DialogHeader><DialogTitle>Nuovo cliente</DialogTitle></DialogHeader>
          <div className="space-y-3">
            <Field label="Nome cliente"><Input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="h-8 rounded-sm" data-testid="customer-name-input" /></Field>
            <Field label="Fuso orario (IANA)" hint="Usato per la finestra di 5 giorni e le date dei report"><Input value={form.timezone} onChange={(e) => setForm({ ...form, timezone: e.target.value })} className="h-8 rounded-sm font-mono" data-testid="customer-timezone-input" /></Field>
            <Field label="Note"><Input value={form.notes} onChange={(e) => setForm({ ...form, notes: e.target.value })} className="h-8 rounded-sm" data-testid="customer-notes-input" /></Field>
          </div>
          <DialogFooter><Button onClick={save} disabled={!form.name} className="rounded-sm bg-[#0047FF]" data-testid="customer-save-btn">Crea cliente</Button></DialogFooter>
        </DialogContent>
      </Dialog>
    </Page>
  );
}
